/**
 * 手动上传文件，并且会带相关参数进去
 * @param method
 * @param headers
 * @param data
 * @returns {FormData}
 */

const manualUpload = ({ method, headers, data }) => {
  if (method === 'post' && headers['Content-Type'] === 'multipart/form-data') {
    const formData = new FormData()

    for (const key in data) {
      if (key === 'file') {
        data[key].forEach(item => {
          formData.append('file', item)
        })
      } else {
        formData.append(key, data[key])
      }
    }
    return formData
  }
}

export default manualUpload
